export default __webpack_public_path__ + "static/media/2NZD.461c3190.svg";